<script>
import Datalayer from 'Controllers/Web/Datalayer';

export default {
  el: '.content',
  data: {
    CourseOrder: Json.CourseOrder,
    pointsUsed: 0,
    discountCode: null,
    discountCodeId: null,
    discountCodeText: '',
    processing: false,
    salesRuleApply: [],
    evTimeStamp: 0,
    outOfStockMsg: Json.outOfStockMsg,
    addToCartOutOfStockMsg: Json.addToCartOutOfStockMsg,
    maxPointPerOrder: Json.maxPointPerOrder,
    miniAmountPerOrder: Json.miniAmountPerOrder,
    userPoints: 0,
    moneyPoints: 0,
    userReachMiniAmountPerOrder: false,
    hasLimitForPointUse: false,
    datalayerPushed: false,
  },
  beforeMount() {
    this.$nextTick(() => {
      $('[data-toggle="popover"]').popover({
        html: true,
        sanitize: false,
        trigger: 'hover',
        placement: 'top',
      });
    });

    this.changeCartsPriceTotal();
    this.userReachMiniAmountPerOrder = this.CourseOrder.payFinalPrice >= this.miniAmountPerOrder ? true : false;
    this.hasLimitForPointUse = this.maxPointPerOrder > 0 ? true : false;
  },
  computed: {
  },
  watch: {
    'CourseOrder.payCartPriceTotal': function (newVal, oldVal) {
      this.userReachMiniAmountPerOrder = newVal - this.CourseOrder.baseDiscountAmount >= this.miniAmountPerOrder ? true : false;
    },
    pointsUsed: function () {
      let totalPoints = this.userPoints + this.moneyPoints;
      if(this.userReachMiniAmountPerOrder == false){
        this.pointsUsed = 0;
      }

      // 確保使用點數不超過最大可折抵金額
      if(this.hasLimitForPointUse && this.pointsUsed > this.maxPointPerOrder){
        this.pointsUsed = this.maxPointPerOrder;
      }

      // 確保使用點數不超過可用點數
      if (this.pointsUsed > totalPoints) {
        this.pointsUsed = totalPoints;
      }

      // 確保使用點數不超過可折抵金額
      if (this.pointsUsed > this.maxPointPerOrder) {
        this.pointsUsed = this.maxPointPerOrder;
      }

      // 確保使用點數大於等於 0
      if (this.pointsUsed < 0) {
        this.pointsUsed = 0;
      }
      /* 確保使用點數 不超過折扣後餘額 */
      let payCartPriceTotal = Math.floor(this.CourseOrder.payCartPriceTotal);
      let discount = Math.floor(this.CourseOrder.baseDiscountAmount);

      if (this.pointsUsed > (payCartPriceTotal - discount)) {
        this.pointsUsed = (payCartPriceTotal - discount);
      }

      this.pointsUsed = Math.floor(this.pointsUsed);
    },
  },
  methods: {
    cartSubmit(){
      if(!this.datalayerPushed){
        $.ajax({
          url: 'shop/order/coursecart/getBeginCheckoutDataLayer',
          type: 'POST',
          data: {
            orderId: this.CourseOrder.id,
          },
          dataType: 'json',
        })
        .done((response) => {
          if(response != null){
            Datalayer.push(response);
            this.datalayerPushed = true;
          }
        });
      }
    },
    changeCartAmount: function (key) {
      var now = +new Date();
      if (now - this.evTimeStamp < 1500) {
        return;
      }
      this.evTimeStamp = now;

      this.processing = true;

      //改變header購物車數字
      var TotalCount = 0;
      TotalCount = this.CourseOrder.Carts.reduce(function (
        accumulator,
        currentValue,
      ) {
        return parseInt(accumulator) + parseInt(currentValue.amount); // 與前一個值相加
      },
      0);
      $('#courseCartCount').text('' + TotalCount);

      var _this = this;

      if (
        isNaN(this.CourseOrder.Carts[key].amount) ||
        this.CourseOrder.Carts[key].amount < 1
      ) {
        //防止前台填入負值或是非數字字元
        this.CourseOrder.Carts[key].amount = 1;
      }

      if(this.CourseOrder.Carts[key].productType == 'simple'){
        /* 防止小於方案基數 */
        if (
            this.CourseOrder.Carts[key].amount <
            this.CourseOrder.Carts[key].CourseSpecification
                .baseNumber
        ) {
          this.CourseOrder.Carts[key].amount =
              this.CourseOrder.Carts[
                  key
                  ].CourseSpecification.baseNumber;
        }
      }


      $.ajax({
        url: 'shop/order/coursecart/changeCartAmount',
        type: 'POST',
        data: {
          cartId: this.CourseOrder.Carts[key].id,
          amount: this.CourseOrder.Carts[key].amount,
          orderId: this.CourseOrder.id,
        },
        dataType: 'json',
      })
        .done(function (response) {
          _this.CourseOrder.isFreeFreight = response.isFreeFreight;
          _this.CourseOrder.tradeinCount = response.tradeinCount;
          _this.CourseOrder.payCartPriceTotal = response.payCartPriceTotal;
          _this.addToCartOutOfStockMsg = response.addToCartOutOfStockMsg;
          _this.CourseOrder.Carts[key].amount = response.returnAmount;
          _this.changeCartsPriceTotal();
        })
        .fail(function (response) {
          _this.processing = false;
        });
    },
    // 計算購物車總金額
    changeCartsPriceTotal() {
      let priceTotal = 0;

      Object.values(this.CourseOrder.Carts).forEach(cartItem => {
        let onlinePrice = 0;
        let itemPrice = 0;
        if(cartItem.productType !== 'tightBundle'){
          itemPrice = parseInt(cartItem.CourseSpecification.price);
        }else{
          itemPrice = cartItem.unitPrice;
          onlinePrice = cartItem.unitPriceWithOutOnline ?? 0;
        }

        let itemAmount = parseInt(cartItem.amount);
        let itemPriceTotal = itemPrice * itemAmount + onlinePrice;

        cartItem.priceTotal = itemPriceTotal;
        priceTotal += itemPriceTotal;
      });

      this.CourseOrder.cartPriceTotal = priceTotal;
      this.CourseOrder.payCartPriceTotal = priceTotal;

      this.getOrderChanges();
    },
    // 計算訂單總金額
    getOrderChanges() {

      axios.get('shop/order/coursecart/getOrderChanges')
          .then((response) => {
            this.CourseOrder.OrderGiftCart = response.data.OrderGiftCart;
            this.CourseOrder.tradeinCount = response.data.tradeinCount;
            this.salesRuleApply = response.data.salesRuleApply;
            this.CourseOrder.payFinalPrice = response.data.payFinalPrice;
            this.CourseOrder.baseDiscountAmount = response.data.baseDiscountAmount;
            this.userPoints = response.data.userPoints;
            this.moneyPoints = response.data.moneyPoints;
            this.maxPointPerOrder = response.data.maxPointPerOrder;
            this.resetPoint();
            this.processing = false;
          });

    },
    resetPoint(){
      this.pointsUsed = 0;
    },
    setDiscountCode() {
      const { discountCode } = this;

      this.discountCodeText = '正在獲取優惠代碼';
      this.processing = true;
      this.outOfStockMsg = [];
      if(discountCode == '' || discountCode == null){
        this.discountCodeText = '請輸入優惠代碼';
        this.processing = false;
        return;
      }
      axios
        .post('shop/order/coursecart/useDiscountCode', {
          discountCode,
        })
        .then((response) => {
          if (response.data.status) {
            this.changeCartsPriceTotal();
            this.discountCodeText = '';
            this.discountCode = null;
          } else {
            this.discountCodeText = response.data.message;
          }
          this.outOfStockMsg = response.data.outOfStockMsg;
          this.processing = false;
        })
        .catch((err) => {
          console.log(err);
          this.processing = false;
        });
    },
    cancelCode(id) {
      let _this = this;
      this.processing = true;
      axios
          .post(
              'shop/order/coursecart/cancelCode',
              {
                id,
              },
          )
          .then((response) => {
            if (response.data.status) {
              this.salesRuleApply.forEach((item, index) => {
                if(item.id == id){
                  _this.salesRuleApply.splice(index, 1);
                }
              });
              this.discountCodeText = '';
              this.discountCode = '';
              this.changeCartsPriceTotal();
            }

            this.processing = false;
          })
          .catch((err) => {
            console.log(err);
            this.processing = false;
          });
    },
    changePayPriceTotal() {
      this.CourseOrder.payFinalPrice =
        this.CourseOrder.payCartPriceTotal -
        this.pointsUsed -
        this.CourseOrder.baseDiscountAmount;
    },
    deleteCart(key) {
    },
  },
  created() {},
};
</script>
